import React from 'react';
import {Provider} from "react-redux";
import configure from "../../store/configure";
import LoginContainer from "./container/LoginContainer";
import Layout from "../../component/layout/Layout";


const LoginPage = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const hstate = searchParams.get("state");
    const alimtalkRef = searchParams.get("ref");

    return (
        <Provider store={configure}>
            <Layout>
                <LoginContainer hstate={hstate} alimtalkRef={alimtalkRef}/>
            </Layout>

        </Provider>
    );
};

export default LoginPage;
